import React from 'react';
import PropTypes from 'prop-types';

import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import ExchangeTitle from './exchange/ExchangeTitle';
import ExchangeBody from './exchange/ExchangeBody';
import NoSubscribedBody from './exchange/NoSubscribedPoints/NoSubscribedBody';

import TrackingLoading from '../../../mis-compras/components/tracking/trackingLoading.gif';
import PointsIcon from '../../../../common/icons/PointsIcon';

import { useContainerStyles } from './styles';

const Points = ({ ...props }) => {
  const { categories, points, mobile, pointsStatus } = props;
  const { Points: pointsMount, subscribed } = points;
  const classes = useContainerStyles();

  return (
    <React.Fragment>
      <ProfileTitle
        title={<strong>Ripley Puntos Go</strong>}
        subtitle="Aquí podrás canjear tus Ripley Puntos Go."
        mobile={mobile}
        icon={<PointsIcon size="30px" color="#6A148E" />}
      />
      {pointsStatus === 'loading' || pointsStatus === 'idle' ? (
        <div className={classes.loadingContainer}>
          <img className={classes.loadingImage} src={TrackingLoading} />
        </div>
      ) : (
        <React.Fragment>
          {subscribed && pointsMount !== 0 && (
            <React.Fragment>
              <ExchangeTitle points={points} />
              <ExchangeBody categories={categories} mobile={mobile} />
            </React.Fragment>
          )}
          {(!subscribed || pointsMount === 0) && (
            <NoSubscribedBody mobile={mobile} />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Points.propTypes = {
  categories: PropTypes.array,
  mobile: PropTypes.bool,
  points: PropTypes.object,
  pointsStatus: PropTypes.string,
};

export default Points;
